import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  companies: null,
  loading: false,
  error: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_COMPANIES_BEGIN:
    case actionTypes.UPDATE_COMPANY_BEGIN:
    case actionTypes.ADD_COMPANY_BEGIN:
      return updateObject(state, { loading: true, error: null });

    case actionTypes.FETCH_COMPANIES_FAILED:
    case actionTypes.UPDATE_COMPANY_FAILED:
    case actionTypes.ADD_COMPANY_FAILED:
      return updateObject(state, {
        loading: false,
        error: action.payload.error
      });

    case actionTypes.FETCH_COMPANIES_SUCCESS:
      return updateObject(state, {
        loading: false,
        error: null,
        companies: action.payload.companies
      });

    case actionTypes.UPDATE_COMPANY_SUCCESS:
      var updatedCompanies = (state.companies || []).map((item, index) => {
        if (item.id !== action.payload.company.id) {
          return item;
        }
        return { ...item, ...action.payload.company };
      });
      return updateObject(state, {
        loading: false,
        companies: updatedCompanies
      });

    case actionTypes.ADD_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        companies: [
          ...state.companies.slice(0, 0),
          action.payload.company,
          ...state.companies.slice(0)
        ]
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/company.js